import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/instances/$instanceId')({
  component: InstanceLayout,
})

function InstanceLayout() {
  return <Outlet />
}
